import PropTypes from "prop-types";
import { Fragment, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import usePrevious from "react-use/lib/usePrevious";
import { v4 } from "uuid";

import {
  addCard,
  demoteCommander,
  openmobileImage,
  promoteToCommander,
  removeCard,
  setViewerImage,
} from "store/clipboard";
import { cardRichType } from "types";

import ClipboardItem from "./ClipboardItem";

const ClipboardItems = ({ commanders, lists, recs }) => {
  const dispatch = useDispatch();
  const recsRef = useRef(null);
  const commanderColorId =
    commanders.length === 0
      ? ["W", "U", "B", "R", "G"]
      : ["W", "U", "B", "R", "G"].filter((c) =>
          commanders
            .map((commander) => commander?.color_identity)
            .flat()
            .includes(c)
        );
  const prevRecs = usePrevious(recs);

  useEffect(() => {
    if (prevRecs?.length === 0 && recs.length > 0) {
      recsRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [recs]);

  const handleShow = (card) => {
    dispatch(setViewerImage(card.image_uri));
    dispatch(openmobileImage());
  };

  return (
    <>
      {commanders?.length > 0 && (
        <Fragment key={v4()}>
          <div className="w-100" key="commander">
            Commander{commanders.length > 1 && "s"}
          </div>
          {commanders
            .filter((commander) => commander)
            .map((commander) => (
              <ClipboardItem
                card={commander}
                key={commander.name}
                legal
                legal_commander
                onDemote={() => dispatch(demoteCommander(commander.url))}
                onRemove={() => dispatch(removeCard(commander.url))}
                onShow={() => handleShow(commander)}
                type="commander"
              />
            ))}
        </Fragment>
      )}
      {Object.values(lists)
        .filter((list) => list.cards.length > 0)
        .sort((a, b) => a.i - b.i)
        .map((list) => {
          list.cards.sort((a, b) => a.cmc - b.cmc);
          return (
            <Fragment key={list.plural}>
              <div className="w-100">{`${list.plural} (${list.cards.length})`}</div>
              {list.cards.map((card) => (
                <ClipboardItem
                  card={card}
                  key={card.name}
                  legal={
                    !card.color_identity ||
                    card.color_identity.filter((c) => !commanderColorId.includes(c)).length === 0
                  }
                  legal_commander={card.legal_commander}
                  onPromote={() => dispatch(promoteToCommander(card))}
                  onRemove={() => dispatch(removeCard(card.url))}
                  onShow={() => handleShow(card)}
                  type="card"
                />
              ))}
            </Fragment>
          );
        })}
      {recs.length > 0 && (
        <Fragment key={v4()}>
          <div className="w-100" key="recs" ref={recsRef}>
            Recs
          </div>
          {recs.map((card, recsIndex) => (
            <ClipboardItem
              card={card}
              key={card.name}
              legal
              onAdd={() => dispatch(addCard({ card, recsIndex }))}
              onPromote={() => dispatch(promoteToCommander(card))}
              onShow={() => handleShow(card)}
              type="rec"
            />
          ))}
        </Fragment>
      )}
    </>
  );
};

ClipboardItems.propTypes = {
  commanders: PropTypes.arrayOf(cardRichType),
  lists: PropTypes.objectOf(
    PropTypes.shape({
      cards: PropTypes.arrayOf(PropTypes.cardRichType),
      i: PropTypes.number,
      plural: PropTypes.string,
    })
  ),
  recs: PropTypes.arrayOf(cardRichType),
};

export default ClipboardItems;
